export default __webpack_public_path__ + "static/media/arrow-black.e62c4804.svg";